import img from '../images/logos/576_Cash Canvas-02.jpg'
export const aboutHero = {
  title: "About CashCanvas",
  subtitle: "Pinch a Penny, Flow to Plenty!",
  description:
    "At CashCanvas, we believe that small, smart financial choices lead to big wins. Our app empowers young professionals, freelancers, couples, and families to take control of their money with ease and confidence.",
  image: img
};

export const whyChoose = {
  title: "Why Choose CashCanvas?",
  points: [
    "AI-powered insights that simplify money management.",
    "Multi-currency support for global finances.",
    "Flexible for every life stage – professionals, freelancers, families.",
    "Private, secure, and built with your trust in mind.",
  ],
  image:img
};

export const mission = {
  title: "Our Mission",
  description:
    "CashCanvas is more than a budgeting tool – it’s your financial co-pilot. Our mission is to make financial management inclusive, secure, and accessible, no matter where you are. With AI-powered insights, CashCanvas helps you master your finances with clarity, ease, and confidence.",
};

export const lookingAhead = {
  title: "Looking Ahead",
  description:
    "We’re excited to expand CashCanvas with support for unique economies in developing countries, offline mobile access, and new AI-driven features. Our goal: make financial competency a part of everyone’s life.",
};

export const contact = {
  title: "Reach Out to Us",
  description:
    "Do you have feedback, a feature request, or partnership ideas? We’d love to hear from you!",
  email: "support@mycashcanvas.com",
};